import React from 'react'
import './MyStory.css'
import Story from '../components/Story'
import Reviews from '../components/Reviews'
import Steps from '../components/Steps'

function MyStory() {
  return (
    <div>
        <Story />
        <Reviews />
        <Steps />
    </div>
  )
}

export default MyStory